<div class="detail-page">
  <div class="container">
    <div class="d-none d-lg-block pt-3">
      <div class="back-button" [routerLink]="'/rewards/auctions'">
        <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
      </div>
    </div>
  </div>

  <div class="container d-lg-none d-block">
    <!-- Points Summary -->
    <fgb-points-summary-bar [backButtonLink]="'/rewards/auctions'"></fgb-points-summary-bar>
  </div>

  <fgbcl-auction-details [auctionId]="id"></fgbcl-auction-details>
</div>
